/**
 * EmbedExpired — a tela de orientação do shell embutido (EMB-10)
 *
 * Mostrada quando o host (a página do parceiro) não responde ao pedido de
 * renovação dentro do tempo limite (EmbedContext, T12) — nunca a tela de
 * login padrão, que este usuário nem tem senha para preencher (context.md
 * decisão 6). A única saída é fechar e reabrir o Inbox: sem senha para
 * digitar, não há nada além disso para o usuário fazer aqui.
 */
import { RefreshCw } from "lucide-react";

export default function EmbedExpired() {
  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-surface-active text-foreground-muted">
        <RefreshCw className="h-6 w-6" aria-hidden="true" />
      </div>
      <div className="max-w-sm space-y-1">
        <h1 className="text-base font-semibold text-foreground-strong">
          Sua sessão expirou
        </h1>
        <p className="text-sm text-foreground-muted">
          Feche esta janela do Inbox e abra novamente para continuar de onde
          parou.
        </p>
      </div>
    </div>
  );
}
